






















import Vue from 'vue';
import { Model, Prop } from 'vue-property-decorator';
import Component from 'vue-class-component';
import CheckboxMarkSVG from '@assets/svg/checkmark.svg';

@Component({
	components: {
		CheckboxMarkSVG
	}
})
export default class Checkbox extends Vue {
	@Model('input', { type: [Array, Boolean], default: false })
	protected readonly checked!: string[] | boolean;

	@Prop({ type: String, default: '' })
	protected readonly name!: string;

	@Prop({ type: String, default: null })
	protected readonly id!: string | null;

	@Prop({ type: String, default: null })
	protected readonly value!: string | null;

	@Prop({ type: String, default: null })
	protected readonly text!: string | null;

	@Prop({ type: Boolean, default: false })
	protected readonly required!: boolean;

	@Prop({ type: Boolean, default: false })
	protected readonly hasError!: boolean;

	protected onChange(event: Event): void {
		// Simple checkbox handling
		if (!Array.isArray(this.checked)) {
			this.$emit('input', (event.target as HTMLInputElement).checked);
			return;
		}

		if (!this.value) {
			return;
		}

		// Array checkbox handling
		const checked: string[] = ([] as string[]).concat(this.checked as string[]);

		if (checked.includes(this.value)) {
			checked.splice(checked.indexOf(this.value), 1);
		} else {
			checked.push(this.value);
		}

		this.$emit('input', checked);
	}

	protected get textWithAsterisk(): string | null {
		if (!this.text) return null;

		const lastClosingParagraphTag = /((<\/p>))(?!.)/g;
		const hasClosingTag = !!this.text.match(lastClosingParagraphTag);

		if (hasClosingTag) {
			return this.text.replace(lastClosingParagraphTag, '&nbsp;*</p>');
		}
		return `${this.text}&nbsp;*`;
	}

	protected get inputId(): string {
		return `${this.id || this.uid}-input`;
	}
}
